import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { SurveyableAssetSubmission } from "../../shared/interfaces/SurveyableAsset";

export function useAddSurveyableAssetToHvSubstation(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation({
    ...callbacks,
    mutationKey: ["addSurveyableAssetToExistingHvSubstation"],
    mutationFn: async (surveyableAssetSubmission: SurveyableAssetSubmission) =>
      apiContext.hvSubstationApis.addSurveyableAssetToExistingHvSubstation(surveyableAssetSubmission),
  });
}
